<pk-navigation-bar *ngIf="showConfigureNavigation"></pk-navigation-bar>
<div class="homepage-container" *ngIf="initData && initData.viewModel">
    <ng-template #template> </ng-template>
    <scroll-to-top *ngIf="disableHtmlHeadTag"></scroll-to-top>
</div>
